/**
 * HTMLタグを文字列から除去する
 * 第二引数にHTMLタグを指定した場合、指定されたHTMLタグは除去されずに残る
 *
 * @param      {string}       str            処理対象の文字列
 * @param      {string[]} arrowTag       許容するHTMLタグ名。配列形式で複数指定可能。
 * @return     {string}       タグが除去された文字列
 */
export const removeTag = function (str: string, arrowTags: string[]): string {
  const arrowTag = arrowTags.join('|')
  const pattern = new RegExp('(?!<\\/?(' + arrowTag + ')(>|\\s[^>]*>))<("[^"]*"|\\\'[^\\\']*\\\'|[^\\\'">])*>', 'gim')
  return str.replace(pattern, '')
}
